'use strict';

import React from 'react'
import ReactDom from 'react-dom'
import ProgressButton from 'react-progress-button'
import DropdownList from 'react-widgets/lib/DropdownList'
import NotificationSystem from 'react-notification-system'
import IstProgress from '../../common/components/progress.jsx'
import IstDialog from '../../common/components/dialog.jsx'
import {ajaxGet, ajaxPost} from '../../common/components/ajax.jsx'
import * as ConstantsURL from '../../common/components/constants.jsx'


export default class LoginForm extends React.Component {
    constructor(props) {
        super(props);

        let checkinmodeFlag = false;

        if (this.getURLParameter('checkinmode') == 'true') {
            checkinmodeFlag = true;
        }

        this.state = {
            items: [],
            buttonState: '',
            tenantarray:[],
            _notificationSystem: null,
            checkinmode: checkinmodeFlag,
            selectTenantId:'',
            component:'loading',
            ac:'',
            tn:'',
            defaultTenantArrayNum:0
        };
    }


    getURLParameter(sParam) {
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i = 0; i < sURLVariables.length; i++) {
            var sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] == sParam) {
                return sParameterName[1];
            }
        }
        return "";
    }

    componentWillMount(){

        let acValue = String(this.getURLParameter('ac'));// レシートからアクセスされた際のアカウント規定値
        let tnValue = String(this.getURLParameter('tn'));// レシートからアクセスされた際のテナントID規定値

        // アカウント名がクエリで指定されていた場合挿入する
        let accountPattern = new RegExp(/^[a-z0-9]+$/);
        if(accountPattern.test(acValue) == true) {
            this.setState({
                ac: acValue
            });
        }

        // テナント名がクエリで指定されていた場合挿入する
        let tenatPattern = new RegExp(/^[0-9]{1,4}/);
        if(tenatPattern.test(tnValue) == true) {
            this.setState({
                tn : tnValue
            });
        }


        ajaxGet(ConstantsURL.GET_AVAILABLE_TENANTS,
            (successJson)=> {
                /* ここでTENANTを取得し、TENANTの中から*/
                console.log(successJson)
                let defaultArrayNum = 0;
                let i = 0;
                successJson.data.map((tenant) => {
                    if(tenant.tenant_id === this.state.tn){
                        console.log(this.state.tn)
                        defaultArrayNum = i;
                    }
                    console.log(i)
                    i++;
                });
                this.setState({
                    tenantarray:successJson.data,
                    component:'loaded',
                    defaultTenantArrayNum:defaultArrayNum,
                    selectTenantId:successJson.data[defaultArrayNum].tenant_id})
            },
            (errorJson)=> {
                setTimeout(reject, 0)
                this._addNotification('Error', 'error', errorJson.message, errorJson.code, errorJson.code)
            }
        )
    }

    componentDidMount() {
        this.state._notificationSystem = this.refs.notificationSystem;
    }


    handleSubmit(e) {
        e.preventDefault()
        let tenant_id = this.state.selectTenantId;
        var id_val = this.refs.id.value.trim();
        var pass_val = this.refs.passcode.value.trim();
        if (!id_val || !pass_val) {
            if (!id_val) {
                this._addNotification("Error", "warning", "アカウントＩＤを入力してください", 1234, 1)
            } else if (!pass_val) {
                this._addNotification("Error", "warning", "パスワードを入力してください", 1234, 2)
            }
            this.setState({
                buttonState:'error'
            })
        } else {
            let postData = {account_user_id: id_val, account_passcode: pass_val,tenant_id:Number(tenant_id)};
            this.setState({
                buttonState:'loading'
            })
            ajaxPost(ConstantsURL.LOGIN, postData,
                (successJson)=> {
                    setTimeout(
                        this.setState({
                            buttonState:'success'
                        })
                        , 0);
                    document.location.href = '/do/menu'
                },
                (errorJson)=> {
                    setTimeout(
                        this.setState({
                            buttonState:'error'
                        })
                        , 0);
                    this._addNotification('Error', 'error', errorJson.message, errorJson.code, errorJson.code)
                }
            )
        }
    }



    _addNotification(title, level, message, errorcode, uid) {
        this.state._notificationSystem.addNotification({
            title: title,
            message: message,
            level: level,
            position: 'tc',
            autoDismiss: 3,
            uid: uid
        });

    }



    selectTenant(idValue){
        this.setState({
            selectTenant: idValue,
            selectTenantId: idValue.tenant_id
        })
    }


    logout(){
        document.location.href='logout://logout'
    }

    render() {
        let header;

        if (!this.state.checkinmode) {
            header = (
                <header>
                    <div id="header_logo"><img id="header_logo_img" src="/resource/img/logo.png" alt="Ist-Reserve"/>
                    </div>
                </header>
            )
        } else {
            header = (
                <header>
                    <div id="header_logo"><img id="header_logo_img" src="/resource/img/logo.png" alt="Ist-Reserve"/>
                    </div>
                    <div className="header_button_back clearfix"><a onClick={this.logout.bind(this)}>中止</a></div>
                </header>
            )
        }


        let showComponent;
        switch(this.state.component){
            case 'loading':

                showComponent = (
                    <div className='container clearfix'>
                        <IstProgress message='しばらくお待ちください' />
                    </div>
                )
                break;

            default:
                showComponent =(
                    <div className='container clearfix'>
                        <div className='side_logo'/>
                        <div className="form-signin">
                            <form className="login_form">
                                <div className='top_logo'/>

                                <div className="form__wrapper">
                                    <h4>学校名</h4>
                                    <DropdownList
                                        valueField='tenant_id'
                                        textField='tenant_name'
                                        onSelect={this.selectTenant.bind(this)}
                                        data={this.state.tenantarray}
                                        defaultValue={this.state.tenantarray[this.state.defaultTenantArrayNum]}
                                    />
                                </div>
                                <div className="form__wrapper">
                                    <h4>アカウントＩＤ</h4>
                                    <input 
                                        type="text"
                                        ref='id'
                                        defaultValue={this.state.ac}
                                        className="form-control default__input"
                                        autoCapitalize="off"
                                        placeholder="アカウントIDを入力してください"
                                        required autofocus/>
                                </div>
                                <div className="form__wrapper">
                                    <h4>パスコード</h4>
                                    <input type="password" ref='passcode' className="form-control default__input"
                                           placeholder="４桁のパスワードを入力してください" required/>
                                </div>
                                <div>
                                    <input id="remember-me" type="checkbox" value="remember-me"/>
                                    <label htmlFor="remember-me" className="checkbox">記憶する</label>
                                </div>
                                <ProgressButton type="submit" onClick={this.handleSubmit.bind(this)}
                                                state={this.state.buttonState}>
                                    ログイン
                                </ProgressButton>
                                <div className="login__explanation">
                                    利用を開始するにはあらかじめ「チェックイン端末」から初回利用登録を行う必要があります。<br />
                                    パスコードを忘れた場合は「チェックイン端末」から学生証を使用してリセットすることができます。
                                </div>
                            </form>
                            <NotificationSystem ref="notificationSystem"/>
                        </div>
                    </div>
                )
                break;

        }



        return (
            <div>
                {header}
                {showComponent}
                <NotificationSystem ref="notificationSystem"/>
                <IstDialog
                    ref="dialog"
                    modal_type="error"
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/jsx/login/components/app.jsx